<template>
  <vs-row>
    <form>
      <vs-row vs-type="flex">
        <vs-col vs-lg="6" vs-sm="12" vs-align="flex-start">
          <vs-input label="Kategória név (kötelező)" v-model="menu.MenuName"></vs-input>
          <vs-input type="number" label="Maximum rendelési idő aznapra (óra)" v-model="menu.MaxOrderHour"></vs-input>
          <vs-select label="Legközelebbi szállítás" v-model="menu.ClosestDelivery">
            <vs-select-item value="today" text="Aznap" selected/>
            <vs-select-item value="next_day" text="Következő nap"/>
          </vs-select>
          <vs-checkbox type="checkbox" v-model="menu.PickupOnly" :vs-value="menu.PickupOnly">Csak elvitelre</vs-checkbox>
          <vs-checkbox type="checkbox" v-model="menu.Visible" :vs-value="menu.Visible">Rendelési oldalon látszik</vs-checkbox>
          <vs-checkbox type="checkbox" v-model="menu.WithBox" :vs-value="menu.WithBox">Ételdoboz választható</vs-checkbox>
        </vs-col>
        <vs-col vs-lg="6" vs-sm="12">
          <label for="fileUpload_edit">
            <input id="fileUpload_edit" type="file" style="visibility: hidden;" accept=".jpg,.png" @input="setImage()">
            <img class="itemImage" alt="Menu Image" :src="imgSrc"/>
          </label>
        </vs-col>
      </vs-row>
      <vs-row>
        <vs-col>
          <vs-input label="Információs szöveg" v-model="menu.InfoText" class="mt-1"></vs-input>
        </vs-col>
      </vs-row>
      <vs-row class="justify-content-center">
        <vs-button @click="save()" color="success" type="gradient" :disabled="isNotSaveable()">Mentés</vs-button>
      </vs-row>
    </form>
  </vs-row>
</template>

<script>
import {axiosInstance} from "@/main";

export default {
  name: "edit_menu",
  props: ['selected'],
  data() {
    return {
      menu: '',
      imgSrc: '',
    }
  },
  watch: {
    selected() {
      this.menu = {...this.selected};
      if (this.selected.MenuFileName)
        this.imgSrc = this.$root.imagePath + this.selected.MenuFileName;
      this.menu.PickupOnly = parseInt(this.menu.PickupOnly);
      this.menu.Visible = parseInt(this.menu.Visible);
      this.menu.WithBox = parseInt(this.menu.WithBox);
    }
  },
  methods: {
    save() {
      let self = this;
      this.$vs.dialog({
        type: 'confirm',
        color: 'success',
        title: `Megerősítés`,
        text: 'Valóban menti a módosításokat?',
        acceptText: 'Igen',
        cancelText: 'Nem',
        accept: function () {
          let input = document.getElementById("fileUpload_edit");
          let form = new FormData();
          if (input !== null && input.files !== null && input.files.length !== 0)
            form.append('menuImage', input.files[0]);
          form.append('menuData', JSON.stringify(self.menu));

          axiosInstance({
            method: 'post',
            url: 'admin/menuController.php?action=edit',
            data: form,
            headers: {'Content-Type': 'multipart/form-data'},
            config: {
              withCredentials: true
            }
          }).then((resp) => {
            self.$vs.notify({
              title: 'Rendszerüzenet',
              position: 'top-right',
              text: resp.data.status === 'OK' ? 'Sikeres mentés.' : 'Sikertelen mentés. ' + resp.data.message,
              color: resp.data.status === 'OK' ? 'success' : 'danger',
              icon: resp.data.status === 'OK' ? 'check_box' : 'error'
            });
            self.$parent.$emit('closemodal');
          })
              .catch((err) => {
                if (err.response.status === 401)
                  self.$root.exterminatus(err.response.data.message);
                else {
                  self.$vs.notify({
                    title: 'Rendszerüzenet',
                    position: 'top-right',
                    text: err.response.data.message,
                    color: 'danger',
                    icon: 'error'
                  });
                }
              });
        }
      });
    },
    isNotSaveable() {
      return !this.menu.MenuName || !this.menu.MaxOrderHour;
    },
    setImage() {
      let self = this;
      let input = document.getElementById("fileUpload_edit");
      if (input.files && input.files[input.files.length - 1]) {
        let reader = new FileReader();
        if (input.files[input.files.length - 1].size / 1024 / 1024 > 2) {
          self.$vs.notify({
            title: 'Rendszerüzenet',
            position: 'top-right',
            text: 'A  fájl mérete túl nagy.',
            color: 'danger',
            icon: 'error'
          });
          input.value = '';
          return;
        }
        reader.readAsDataURL(input.files[input.files.length - 1]);
        reader.onload = function (e) {
          self.imgSrc = e.target.result
        };
      }
    }
  }
}
</script>

<style scoped>
.con-vs-checkbox {
  margin-top: 15px;
}

.vs-input, .con-select {
  margin-top: 5px;
  margin-bottom: 5px;
  width: 100%;
}

.vs-textarea-primary {
  margin-top: 15px;
}

form {
  width: 100%;
}

label {
  text-align: center;
}

.itemImage {
  border: 1px solid #ccc;
  width: 270px;
  height: 190px;
  overflow: hidden;
  border-radius: 10px;
  object-fit: cover;
  cursor: pointer;
  background-size: cover;
}
</style>